import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FeedbackFormWrapper.css';

interface IFeedbackFormWrapperProps {
  children: React.ReactNode;
}

export const FeedbackFormWrapper: React.FC<IFeedbackFormWrapperProps> = ({ children }) => {
  const deviceType = useDeviceType();

  if (deviceType === 'phone') {
    return <>{children}</>;
  }

  return <div className={styles['content']}>{children}</div>;
};
